<template>
  <div class="Appraisal" v-show="token">
    <div class="conter">
      <div class="banner"></div>
      <div class="box clearfix" style="display: block">
        <div class="text">
          <div>
            <span>测试人</span>
            <span>测试时间</span>
          </div>
          <div>
            <span>{{this.user_name}}</span>
            <span>{{this.test_time}}</span>
          </div>

        </div>
        <div id="top">
          <div id="main" style="width:100%;height:1rem;" ref="chart"></div>
          <span class="subtext">{{this.score_1}}</span>
          <span class="subtext1">{{this.score_2}}</span>
          <span class="subtext2">{{this.score_3}}</span>
          <span class="subtext3">{{this.score_4}}</span>
          <span class="subtitle">分</span>
          <span class="subtitle1">分</span>
          <span class="subtitle2">分</span>
          <span class="subtitle3">分</span>
        </div>
        <ul class="list">
          <li style="color: #0789FD;">销售技能</li>
          <li style="color: #1FC6D0;">专业能力</li>
          <li style="color: #FCA33D;">行业前沿</li>
          <li style="color: #8072D6;">素质能力</li>
        </ul>
      </div>
      <div class="jiedu_1">
        <div>
          <h3>总体解读</h3>
        </div>
      </div>
      <div class="dengji_1">
        <p>您的等级是：</p>
        <span>{{this.user_rank_name}}</span>
      </div>
      <div class="liebiao_1">
        <ul style="font-size: .24rem;">
          <li>
            您掌握了一定的获客能力，了解基金、固收等产品，对于前沿业务发展的解读有待提高，请注意理财素质的拓展。
          </li>
          <li>
            与其他测试者相比，您在客户理解、市场洞察、跨行业知识方面表现优秀，在产品认知、跨行业知识有提升空间。
          </li>
          <li>
            综合评判，您是一位很有潜力的{{this.user_rank_name}}，通过系统专业的学习，能在财富管理道路上取得优异成绩。
          </li>
        </ul>
      </div>
      <div>
      	<div id="radar" style="width: 100%;height:300px;" ref="radar"></div>
      </div>
      <div>
      </div>
      <div class="jiedu_1">
        <div>
          <h3>课程匹配</h3>
        </div>
      </div>
      <div class="dengji_1">
        <p>
          您的水平适合学习：
        </p>
        <span>{{this.user_rank_name}}系列课程</span>
      </div>
      <div class="lisr" style="font-size: .24rem;">
        <p>方向</p>
        <p>知识点</p>
        <p>课程</p>
        <p>时长</p>
        <p>难度</p>
      </div>
      <div class="biaoge_1" v-for="topv in top">
        <table  class="tftable">
          <tr>
            <td  style="width: 1.3rem;text-align: center;">{{ topv.name }}</td>
            <td style="display: flex;justify-content: space-around;background-color: #fff; align-items: center" v-for="listv in list" v-show=" topv.id == listv.parent_id">
              <div style="width: 0.5rem;">{{listv.name}}</div>
              <div>{{listv.goods_num}}</div>
              <div>{{parseInt(listv.play_time/36)/100}}小时</div>
              <div>{{course_level}}</div>
            </td>
          </tr>
        </table>
      </div>


      <div class="jiedu_1" >
        <div>
          <h3>学习成绩</h3>
        </div>
      </div>
      <div class="dengji_1" v-if="this.user_level !=4">
        <p>
          预计您学习完成后将达到的能力成就：
        </p>
        <span>{{this.next_user_rank_name}}</span>
          <div class="imges_1" v-if="this.user_level ==1">
              <img src="//images.jinku.com/newjk/org/images/elite_images/expret_03.png" alt="" >
          </div>
          <div class="imges_1" v-if="this.user_level ==2">
              <img src="//images.jinku.com/newjk/org/images/expert_images/expert_lock_03.png" alt="" >
          </div>
          <div class="imges_1" v-if="this.user_level ==3">
              <img src="//images.jinku.com/newjk/org/images/elite_images/lombard_lock_03.png" alt="">
          </div>
      </div>

      <div>
      	<div id="radars" style="width: 100%;height:300px;" ref="radars"></div>
      </div>
      <div>
      </div>
      <div class="zhdjz">
        <p @click="toRoute()">开始学习之旅</p>
      </div>
    </div>
    <bar></bar>
  </div>
</template>

<script>
  import http from "../../lib/http";
  import param  from "../../lib/const";
  import bar from "../tab-bar/bar.vue";
  const echarts = require('echarts');
  export default {
    name: 'CpResult',
    data() {
          return {
            score_1:0, score_2:0, score_3:0, score_4:0,
            score_5:0, score_6:0, score_7:0, score_8:0, score_9:0,
            score_10:0, score_11:0, score_12:0, score_13:0, score_14:0,  //平均成绩
            user_name:"",test_time:0,user_rank_name:"",user_level:0,
        //     四个圈  销售技能：80 专业能力：85  行业前沿：85  素质能力：80
        //
        // 雷达图      客户理解=》 产品认知=》 发展潜力 =》跨行业知识 =》市场洞察
              //总分
              total_score_1:80, total_score_2:85, total_score_3:85, total_score_4:80,
              total_score_5:100, total_score_6:100, total_score_7:100, total_score_8:100, total_score_9:100,
              next_user_rank_name:"",
              top:[],list:[],
              course_level:"",
              token:false,
              user_id:'',
              list1: ['2299652','2351570',' 2351572', '2351574', '2351576', '2351578'],
          }
    },
    components:{
        bar
    },
    methods: {
        toRoute(){
            if (navigator.userAgent.indexOf(';wealthmanagement-android') != -1) {
                window.bridge.transTab(2);
            }else if (navigator.userAgent.indexOf(';wealthmanagement-iOS') != -1) {
               window.webkit.messageHandlers.tabBarSelect.postMessage('route');
            }else {

                if(this.user_level==1){
                    this.$router.push("/Newble");
                }else if(this.user_level==2){
                    this.$router.push("/Expert");
                }else if(this.user_level==3){
                    this.$router.push("/Elite");
                    this.list1.forEach((item,i) =>{
                        if (this.user_id == item) {
                            this.$router.push("/Elitev2");
                        }
                    })

                }else if(this.user_level==4){
                    this.$router.push("/Lombard");
                }
            }
        },
        myEcharts() {
        let myChart = echarts.init(this.$refs.chart);
        myChart.setOption({
          color: ['rgba(0,0,0,.1)'], //颜色
          series: [{
              name: '',
              type: 'pie',
              center: ['11%', '50%'],
              radius: ['65%', '85%'],
              avoidLabelOverlap: true,
              hoverAnimation: false,
              label: {
                normal: {
                  show: true,
                  position: 'left'
                },
                emphasis: {
                  show: false
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              data: [{
                  value: this.score_1,
                  name: '',
                   itemStyle: {
                     normal: {
                         color: '#068CFD'
                     }
                 },
                },
                {
                  value: this.total_score_1 - this.score_1,
                  name: '',

                }
              ]
            },
            {
              name: '',
              type: 'pie',
              radius: ['65%', '85%'],
              center: ['36%', '50%'],
              avoidLabelOverlap: true,
              hoverAnimation: false,

              label: {
                normal: {
                  show: true,
                  position: 'center'
                },
                emphasis: {
                  show: false
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              data: [{
                  value: this.score_2,
                  name: '',
                  itemStyle: {
                      normal: {
                          color: '#1EC5CF'
                      }
                  },
                },
                {
                  value: this.total_score_2 - this.score_2,
                  name: ''
                }
              ]
            },
            {
              name: '',
              type: 'pie',
              radius: ['65%', '85%'],
              center: ['61%', '50%'],
              avoidLabelOverlap: true,
              hoverAnimation: false,
              label: {
                normal: {
                  show: true,
                  position: 'right'
                },
                emphasis: {
                  show: false
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              data: [{
                  value: this.score_3,
                  name: '',
                  itemStyle: {
                      normal: {
                          color: '#FBA13B'
                      }
                  },
                },
                {
                  value: this.total_score_3 - this.score_3,
                  name: ''
                }
              ]
            },
            {
              name: '',
              type: 'pie',
              radius: ['65%', '85%'],
              center: ['85%', '50%'],
              avoidLabelOverlap: true,
              hoverAnimation: false,
              label: {
                normal: {
                  show: true,
                  position: 'left'
                },
                emphasis: {
                  show: false
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              data: [{
                  value: this.score_4,
                  name: '',
                  itemStyle: {
                      normal: {
                          color: '#7F71D5'
                      }
                  },
                },
                {
                  value: this.total_score_4 - this.score_4,
                  name: ''
                }
              ]
            }
          ]
        })
        },
        myrAdar(){
        let myRadar = echarts.init(this.$refs.radar);
        myRadar.setOption({
          legend: {
              data: [ this.user_name,'平均成绩'],
              bottom: 20,
          },

          radar: {
              name: {//字体样式
                  textStyle: {
                      color: '#007FCE',
                      borderRadius: 3,
                      padding: [10, 10]
                  }
              },
              nameGap: 3,
              shape: 'polygon',
              indicator: [
                  {text: '客户理解', max: this.total_score_5},
                  {text: '产品认知', max: this.total_score_6},
                  {text: '发展潜力', max: this.total_score_7},
                  {text: '跨行业知识', max: this.total_score_8},
                  {text: '市场洞察', max: this.total_score_9}
              ],
              //偏移属性和大小
              radius: 80,
              center: ['50%', '40%'],
              splitLine: {     //配置雷达图的每一圈的网格线颜色
                  lineStyle: {
                      color: '#007FCE',
                  },
              },
              splitArea: {     //配置雷达图的网格线背景
                  show: false,
              },
              axisLine: {     //配置雷达图的射线样式颜色
                  lineStyle: {
                      color: '#76B9ED',
                  },
              },
          },
          color:['#899FFD','#A1F3F9'],
          series: [{
              type: 'radar',
              tooltip: {
                  trigger: 'item',
              },
              data: [
                  {
                      value: [this.score_5, this.score_6, this.score_7, this.score_8, this.score_9],
                      name: this.user_name,
                      symbol: "none",//默认不显示 圈圈
                      areaStyle: {
                          normal: {
                              color: '#899FFD' // 选择区域颜色
                          }
                      },
                  },
                  {
                      value: [this.score_10, this.score_11, this.score_12, this.score_13, this.score_14],//平均成绩
                      name: '平均成绩',
                      symbol: "none",
                      areaStyle: {
                          normal: {
                              color: '#A1F3F9' // 选择区域颜色
                          }
                      }
                  }
              ]
          }]
        })
        },
        myRadars(){
        let myRadars = echarts.init(this.$refs.radars);
        myRadars.setOption({
          legend: {
              data: ['学习前', '学习后'],
              bottom: 20
          },

          radar: {
              name: {//字体样式
                  textStyle: {
                      color: '#26A3F9',
                      borderRadius: 3,
                      padding: [10, 10]
                  }
              },
              nameGap: 3,
              shape: 'polygon',
              indicator: [
                  {text: '客户理解', max: 100},
                  {text: '产品认知', max: 100},
                  {text: '发展潜力', max: 100},
                  {text: '跨行业知识', max: 100},
                  {text: '市场洞察', max: 100}
              ],
              //偏移属性和大小
              radius: 80,
              center: ['50%', '40%'],
              splitLine: {     //配置雷达图的每一圈的网格线颜色
                  lineStyle: {
                      color: '#007FCE',
                  },
              },
              splitArea: {     //配置雷达图的网格线背景
                  show: false,
              },
              axisLine: {     //配置雷达图的射线样式颜色
                  lineStyle: {
                      color: '#007FCE',
                  },
              },
          },
          color:['#A1F3F9','#899FFD'],
          series: [{
              type: 'radar',
              tooltip: {
                  trigger: 'item',
              },
              data: [

                  {
                      value: [parseInt((this.score_5+100)/2), parseInt((this.score_6+100)/2),parseInt((this.score_7+100)/2), parseInt((this.score_8+100)/2), parseInt((this.score_9+100)/2)],
                      name: '学习后',
                      symbol: "none",
                      areaStyle: {
                          normal: {
                              color: '#A1F3F9' // 选择区域颜色
                          }
                      }
                  },
                {
                    value: [this.score_5, this.score_6, this.score_7, this.score_8,this.score_9],
                    name: '学习前',
                    symbol: "none",//默认不显示 圈圈
                    areaStyle: {
                        normal: {
                            color: '#899FFD' // 选择区域颜色
                        }
                    },
                }
              ]
          }]
        })
        },
        star(){
        this.$router.push({
          path:'/Newble'
        })
        },
        getResult(){
          const self = this;
          return http({
              method: "post",
              url: "/org/evaluation/get-score",
              data: ""
          }).then(function(res){
            self.score_1 = res.data.score_1;
            self.score_2 = res.data.score_2;
            self.score_3 = res.data.score_3;
            self.score_4 = res.data.score_4;
            self.score_5 = res.data.score_5;
            self.score_6 = res.data.score_6;
            self.score_7 = res.data.score_7;
            self.score_8 = res.data.score_8;
            self.score_9 = res.data.score_9;
            self.score_10 = res.data.score_10;
            self.score_11 = res.data.score_11;
            self.score_12 = res.data.score_12;
            self.score_13 = res.data.score_13;
            self.score_14 = res.data.score_14;
            self.test_time= res.data.submit_time;
            self.initEcharts();
          }).catch(function(err){

          });

        },
        getUserInfo(){
            const self = this;
            return http({
                method: "post",
                url: "/org/user/get",
                data: ""
            }).then(function(res){
                self.user_name = res.data.user_name;
                self.user_id = res.data.user_id;
                self.user_level = res.data.org_user_level;
                self.user_rank_name = res.data.org_user_rank_name
                if(self.user_level <4 && self.user_level >0){
                    var next_user_level = self.user_level+1;
                    if(param.USER_LEVEL_NAME[param.BANKING_ID][next_user_level] != undefined){
                        self.next_user_rank_name = param.USER_LEVEL_NAME[param.BANKING_ID][next_user_level] ;
                    }
                }
                if(param.COURSE_LEVEL_NAME[param.BANKING_ID][self.user_level] != undefined){
                    self.course_level = param.COURSE_LEVEL_NAME[param.BANKING_ID][self.user_level];
                }
            }).catch(function(err){

            });


        },
        initEcharts(){
            this.myEcharts();
            this.myrAdar();
            this.myRadars();
        },
        getCourse(){
            const self = this;
            return http({
                method: "post",
                url: "/org/evaluation/get-course",
                data: ""
            }).then(function(res){
                if(res.code==0){
                    self.top = res.data.top;
                    self.list = res.data.list;
                }

            }).catch(function(err){

            });
        }
    },
    created() {
        var self = this;
        Promise.all([self.getCourse(), self.getResult(), self.getUserInfo()]).then(function(res){
            self.initEcharts();
        });
        var isToken = document.cookie.split(';');
        if(isToken!=""){
            this.token = true;
        }
    }
  }
</script>

<style scoped>
  .conter {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .banner {
    width: 100%;
    height: 5.32rem;
    background-image: url(//images.jinku.com/newjk/org/images/banner_H5_01.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;

  }

  .box {
    width: 6.75rem;
    height: 3.3rem;
    background: white;
    border-radius: .25rem;
    margin: 10px auto;
    z-index: 99;
    /* border: 1px solid silver; */
    -moz-box-shadow: 1px 1px 7px #888888;
    /* 老的 Firefox */
    box-shadow: 1px 1px 7px #888888;
  }

  .text {
    width: 5.45rem;
    margin: 0 auto;
  }

  .text div:nth-child(1) {
    color: #7E7E7E;
    padding-top: .43rem;
    padding-bottom: .17rem;
    font-size: .22rem;
  }

  .text div:nth-child(2) {
    font-size: .28rem;
    line-height: .28rem;
    padding-bottom: .42rem;

  }

  .text div span:nth-child(2) {
    float: right;
  }

  .clearfix {
    zoom: 1;
  }

  .clearfix:after {
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }

  .jiedu_1 {
    position: relative;
    margin: 0.6rem 0 0 0.5rem;
  }

  .jiedu_1>div {
    width: 1.3rem;
    height: 0.2rem;
    background-color: #FFE4C6;
    position: absolute;
    text-align: center;
  }

  .jiedu_1>div>h3 {
    font-size: .31rem;
    margin: -0.2rem 0px 0px 0px;
    font-family: SourceHanSansCN-Bold;
  }

  .dengji_1 {
    margin-top: 1.25rem;
    margin-left: 0.5rem;
  }

  .dengji_1>p {
    display: inline-block;
    font-size: .26rem;
  }

  .dengji_1>span {
    display: inline-block;
    color: #4EB2FE;
    font-size: .26rem;
  }

  .liebiao_1 {
    padding: 0.5rem;
    padding-top: 0rem;
  }

  .liebiao_1>ul>li {
    margin-top: 0.3rem;
    color: #5D5D5D;
  }

  table.tftable {
    font-size: 12px;
    color: #333333;
    width: 100%;
    border-width: 1px;
    border-color: #729ea5;
    border-collapse: collapse;
  }

  table.tftable th {
    font-size: 12px;
    background-color: #acc8cc;
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #729ea5;
    text-align: left;
  }

  table.tftable tr {
    background-color: #d4e3e5;
  }

  table.tftable td {
    font-size: .22rem;
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #729ea524;
  }

  .biaoge_1 {
    padding: 0.5rem;
    padding-top: 0.3rem;
    padding-bottom: 0;
  }

  .lisr {
    width: 87%;
    height: 0.7rem;
      line-height: .7rem;
    background-color: #EAF6FF;
    margin: 0.5rem;
    margin-bottom: 0;
    display: flex;
    justify-content: space-evenly;ƒ
    line-height: 0.7rem;
    border-bottom: 0.04rem solid #000;
  }

  .imges_1>img {
    width: 50%;
  }
  .imges_1{
      text-align: center;
  }

  .zhdjz {
    padding: 0.5rem;
    padding-top: 0;
  }

  .zhdjz>p {
    width: 100%;
    height: 1rem;
    cursor: pointer;
    background-image: linear-gradient(to right, #FD8333, #FC6029);
    color: #fff;
    text-align: center;
    line-height: 1rem;
    border-radius: 1rem;
    font-size: 0.35rem;
    margin-bottom: 1rem;
  }

  #top {
    height: 1.1rem;
    margin: 0 .61rem 0 .66rem;
    position: relative;
  }

  #top div {
    flex: 1;
  }

  .list {
    width: 81%;
    height: .21rem;
    line-height: .21rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: .22rem;
    margin: auto;
    margin-left: .8rem;
  }

  .list li {
    flex: 1;
  }
.subtext,.subtext1,.subtext2,.subtext3{
  position: absolute;
  top: 20%;
  font-size: .24rem;
}
  .subtext {
    left: 8.5%;
    color: #0789FD;
  }
.subtext1{
  left: 33.5%;
  color: #1EC5CF;
}
.subtext2{
  left: 58.5%;
  color: #FBA13B;
}
.subtext3{
  left: 82.5%;
  color: #7F71D5;
}
.subtitle,
.subtitle1,
.subtitle2,
.subtitle3{
  position: absolute;
  top: 44%;
  font-size: .14rem;
}
.subtitle{
  left: 9%;
  color: #0789FD;
}
.subtitle1{
  left: 34%;
  color: #1EC5CF;
}
.subtitle2{
  left: 59%;
  color: #FBA13B;
}
.subtitle3{
  left: 83%;
  color: #7F71D5;
}
</style>



// WEBPACK FOOTER //
// src/components/ceping/result.vue